import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };

const fields = [{
    name: 'email',
    type: 'email',
    label: 'Login.Email',
    placeholder: 'Login.Email',
    rules: 'required|email|string|between:5,64',
}, {
    name: 'company',
    label: 'Login.CompanyName',
    placeholder: 'Login.CompanyName',
    rules: 'required|string|between:2,64',
}, {
    name: 'firstname',
    label: 'Login.Firstname',
    placeholder: 'Login.Firstname',
    rules: 'required|string|between:2,64',
}, {
    name: 'lastname',
    label: 'Login.Lastname',
    placeholder: 'Login.Lastname',
    rules: 'required|string|between:2,64',
}, {
    name: 'password',
    type: 'password',
    label: 'Login.Password',
    placeholder: 'Login.Password',
    rules: 'required|string|between:8,64',
}];


class SignupForm extends MobxReactForm {
    onSuccess = () => { // add form to () if needed
        // console.log('Form is valid! Send the request here.');
        // get field values
        // console.log('Form Values!', form.values());
    };

    onError = (form) => {
        // get all form errors
        // console.log('All form errors', form.errors());
        // invalidate the form with a custom error message
        form.invalidate('Please fix the errors on the form before submitting again!');
    }
}

export default new SignupForm({ fields }, { plugins });
